<template>
  <div>
    <partHeader :title="title"></partHeader>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="140px"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="参加工作时间" prop="toWorkDate">
            <el-date-picker
              v-model="form.toWorkDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :disabled="disabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="现工作单位" prop="company">
            <el-input
              v-model="form.company"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="现工作部门" prop="department">
            <el-input
              v-model="form.department"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职务或岗位" prop="post">
            <el-input
              v-model="form.post"
              placeholder="请输入"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专业技术资格及取得时间">
            <!-- <el-date-picker
              v-model="form.ExpertiseObtainDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :disabled="disabled"
            ></el-date-picker> -->
            <el-input
              v-model="form.ExpertiseObtainDate"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="技能等级及取得时间">
            <!-- <el-date-picker
              v-model="form.appointmentDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :disabled="disabled"
            ></el-date-picker> -->
             <el-input
              v-model="form.appointmentDate"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import partHeader from "./partHeader.vue";
export default {
  name: "currentWorkPart",
  components: {
    partHeader
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: "现工作情况",

      form: {
        toWorkDate: "", //参加工作时间
        company: "", //现工作单位
        department: "", //现工作部门
        post: "", //职务或岗位
        ExpertiseObtainDate: "", //专业技术资格取得时间
        appointmentDate: "" //现聘专业技术岗位及聘任时间
      },
      rules: {
        toWorkDate: [
          { required: true, message: "请选择参加工作时间", trigger: "blur" }
        ],
        company: [
          { required: true, message: "请填写现工作单位", trigger: "blur" }
        ],
        department: [
          { required: true, message: "请填写现工作部门", trigger: "blur" }
        ],
        post: [
          { required: true, message: "请填写职务或岗位", trigger: "blur" }
        ],
        ExpertiseObtainDate: [
          {
            required: true,
            message: "请选择专业技术资格取得时间",
            trigger: "blur"
          }
        ],
        appointmentDate: [
          { required: true, message: "请选择聘任时间", trigger: "blur" }
        ],
        validated: false
      }
    };
  },
  mounted() {
    if (!this.$route.params.isTj) {
      this.form.toWorkDate = this.dateFormat(this.item.cjgzsj);
      this.form.company = this.item.xgzdw;
      this.form.department = this.item.xbm;
      this.form.post = this.item.zwhgw;
      this.form.ExpertiseObtainDate = this.item.zyjszgjhdsj;
      this.form.appointmentDate = this.item.xpzyjsgwjprsj;
    }
  },
  methods: {
    validate() {
      this.validateForm();
      if (this.validated) {
        let para = {
          cjgzsj: this.form.toWorkDate,
          xgzdw: this.form.company,
          xbm: this.form.department,
          zwhgw: this.form.post,
          zyjszgjhdsj: this.form.ExpertiseObtainDate,
          xpzyjsgwjprsj: this.form.appointmentDate
        };
        return para;
      }
      return null;
    },
    validateForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.validated = true;
        } else {
          this.validated = false;
        }
      });
    },
    reset() {
      this.$refs.form.resetFields();
    },
    dateFormat(date) {
      if (date) {
        return (
          date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2)
        );
      }
      return "";
    }
  }
};
</script>
